<template>
  <div class="form d-flex justify-content-between" :style="color">
    <transition name="fade">
      <div v-if="modal" class="dialog-overlay" @click.self="modal = false">
        <transition name="bounce" appear>
          <div class="dialog">
            <div v-if="appointmentLoading" class="dialog-loading-overlay">
              <div
                class="spinner-border"
                style="width: 3rem; height: 3rem;"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div class="dialog-header">
              Запись на прием к врачу <span v-if="typeAppointment===1">по видеосвязи</span>
            </div>
            <div class="dialog-content">
              <div class="mv-time">
                {{ shortTimestamp.toUpperCase() }}
              </div>
              <!--div class="mv-list">
                <div class="mv-item">
                  <div class="mv-name">Врач</div>
                  <div class="mv-value">{{ doctor.name }}</div>
                </div>
                <div class="mv-item">
                  <div class="mv-name">Специальность</div>
                  <div class="mv-value">{{ specialty.title }}</div>
                </div>
                <div class="mv-item">
                  <div class="mv-name">Отделение</div>
                  <div class="mv-value">{{ doctor.department }}</div>
                </div>
              </div-->
              
              <div class="item">
              <div style="width: 90%; position:absolute; height:5px; background:linear-gradient(to right, rgba(137, 48, 216, 0.4), rgba(92, 72, 212, 0.3))"></div>
              <div class="item-logo" style="margin-left:30px; z-index:2; background:white; border:4px whitesmoke solid">
                <img v-if="current_doctor.avatar" :src="current_doctor.avatar" alt="logo" />
                <svg
                  v-else
                  class="bi bi-camera"
                  width="1em"
                  height="1em"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M9 5C7.343 5 5 6.343 5 8a4 4 0 0 1 4-4v1z" />
                  <path
                    fill-rule="evenodd"
                    d="M14.333 3h-2.015A5.97 5.97 0 0 0 9 2a5.972 5.972 0 0 0-3.318 1H1.667C.747 3 0 3.746 0 4.667v6.666C0 12.253.746 13 1.667 13h4.015c.95.632 2.091 1 3.318 1a5.973 5.973 0 0 0 3.318-1h2.015c.92 0 1.667-.746 1.667-1.667V4.667C16 3.747 15.254 3 14.333 3zM1.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM9 13A5 5 0 1 0 9 3a5 5 0 0 0 0 10z"
                  />
                  <path d="M2 3a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1z" />
                </svg>
              </div>
              <div class="vm-item-info">
              <div class="title">{{ current_doctor.name }}</div>
                  <div class="subtitle">{{ current_doctor.department }} / {{ current_doctor.specialty }}</div>
              </div>
            </div>
            </div>
            <div class="dialog-footer">
              <button @click="modal = false">Отмена</button>
              <button @click="appointmentSlot()">Записаться</button>
            </div>
          </div>
        </transition>
        <div v-if="true"></div>
      </div>
    </transition>
    <div style="width:100%" v-if="step === 0">
      <h5>
        Выберите врача:
      </h5>
      <!--v-select
        class="spetialty-select"
        placeholder="Выберите специальность..."
        label="title"
        v-model="specialty"
        :clearable="false"
        :loading="specialtiesLoading"
        :options="specialties"
      >
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes">
            <b-icon icon="chevron-down"></b-icon>
          </span>
        </template>
      </v-select-->
      <div style="display:flex; width:100%; justify-content:space-between">
      <div class="list-wrap" style="width:45%;">
        <div class="headtitle" :style="linearGradient">Специальность</div>
        <transition name="fade">
          <ul class="specialities_list" style="height:40vh; overflow:auto; ">
            <li class="special_item" v-for="special in specialties" v-bind:key="special.id">
              <div class="special" :style="special === specialty ? highlightLinearGradient : {}" @click="specialty=special">{{ special.title }}</div>
            </li>
          </ul>
        </transition>
      </div>
    <div class="list-wrap" style="width:45%">
        <div class="headtitle" :style="linearGradient">Доктора</div>
        <transition name="fade">
          <ul class="specialities_list" style="height:40vh; overflow:auto">
            <li class="special_item" v-for="special in doctors"  v-bind:key="special.id">
              <div class="special" :style="special === current_doctor ? highlightLinearGradient : {}" @click="clickCurrentDoctor(special)">{{ special.name }}</div>
            </li>
            <div v-if="specialty && !doctors.length" class="empty-list">
            Нет врачей с выбраной специальностью...
          </div>
          </ul>
        </transition>
    </div>  
    </div>
      <div class="doctors">
        <div v-if="!loading">
          <!--div class="doctor-card" v-for="doctor in doctors" :key="doctor.id">
            <div class="info pr-4">
              <div class="title">{{ doctor.name }}</div>
              <div class="subtitle">{{ doctor.department }}</div>
            </div>
            <div class="more">
              <button @click="selectDoctor(doctor, 0)" class="appointment-button">
                Записаться
              </button>
              <button @click="selectDoctor(doctor, 1)" class="appointment-button" style="margin-left:15px">
                Записаться на видеоконсультацию
              </button>
            </div>
          </div-->
          <CustomList v-if="current_doctor" :item="current_doctor" :loading="loading" :avatar="current_doctor.avatar">
            <template slot="info">
                  <div class="title">{{ current_doctor.name }}</div>
                  <div class="subtitle">{{ current_doctor.department }} / {{ current_doctor.specialty }}</div>
              </template>
              <template slot="rightSideInfo">
                <template v-if="current_doctor.freeDates">
                  <button :style="reverseLinearGradient" @click="selectDoctor(current_doctor, 0)" class="vm-button ara">
                    Записаться
                  </button>
                  <button :style="reverseLinearGradient" @click="selectDoctor(current_doctor, 1)" class="vm-button ara" style="margin-left:15px">
                    Записаться на видеоконсультацию
                  </button>
                </template>
                <template v-else>
                  Запись не ведется
                </template>
            </template>
          </CustomList>
          <div v-if="specialty && !doctors.length" class="empty-list">
            Нет врачей с выбраной специальностью...
          </div>
        </div>
        <div v-else>
          <CustomList >
            <template slot="info">
                  <div class="title loading-block" style="width:300px;height:50px"></div>
              </template>
              <template slot="rightSideInfo">
              <div disabled class="appointment-button loading-block" style="width:200px; height:40px">
                
              </div>
              <div disabled class="appointment-button loading-block" style="margin-left:15px; width:300px; height:40px">
                
              </div>
            </template>
          </CustomList>
          <!--div class="doctor-card loading">
            <div class="info pr-4">
              <div class="title loading-block"></div>
              <div class="subtitle loading-block"></div>
            </div>
            <div class="more loading-block"></div>
          </div>
          <div class="doctor-card loading">
            <div class="info pr-4">
              <div class="title loading-block"></div>
              <div class="subtitle loading-block"></div>
            </div>
            <div class="more loading-block"></div>
          </div>
          <div class="doctor-card loading">
            <div class="info pr-4">
              <div class="title loading-block"></div>
              <div class="subtitle loading-block"></div>
            </div>
            <div class="more loading-block"></div>
          </div-->
        </div>
      </div>
    </div>
    <div v-else-if="step === 1">
      <div class="header">
        <div class="selected-doctor" style="width:100%">
          <CustomList :item="current_doctor" :avatar="current_doctor.avatar">
                <template slot="info">
                  <div class="title">{{ current_doctor.name }}</div>
                  <div class="subtitle">{{ current_doctor.department }} / {{ current_doctor.specialty }}</div>
                </template>
                <template slot="rightSideInfo">
                  <button
                    class="vm-button" :style="reverseLinearGradient" style="margin-top: 20px" @click="toBack(0)"
                  >
                    Поменять врача
                  </button>
                </template>
              </CustomList>
        </div>
        <!--button @click="toBack(0)" class="appointment-button">
          Поменять врача
        </button-->
      </div>
      <div class="timetable">
        <div class="fullcalendar-wrap">
          <div v-if="timetableLoading" class="overlay">
            <div
              class="spinner-border"
              style="width: 3rem; height: 3rem;"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <FullCalendar
            defaultView="dayGridMonth"
            :plugins="calendarPlugins"
            selectable="true"
            :showNonCurrentDates="false"
            :height="550"
            :locale="locale"
            @dateClick="dateClick"
            @datesRender="handleDatesRender" ref="fullCalendar" @click="test($event)"
          />
        </div>
        <div class="sidebar">
          <div v-if="selectedDate">
            <div class="title">
              Доступные записи на
              <br />
              {{ shortDate }}
            </div>
            <div v-if="!slotsLoading" class="slots">
              <button
                class="slot"
                :class="{ selected: item === slot }"
                v-for="item in slots"
                :key="item.id"
                :disabled="item.record_mode === 1"
                 :title="item.record_mode === 1 ? 'запись только по телефону' : 'свободное время'"
                @click="selectSlot(item)"
              >
                {{ item.time }}
              </button>
            </div>
            <div v-else class="slots loading">
              <div class="slot loading-block"></div>
              <div class="slot loading-block"></div>
              <div class="slot loading-block"></div>
              <div class="slot loading-block"></div>
              <div class="slot loading-block"></div>
              <div class="slot loading-block"></div>
              <div class="slot loading-block"></div>
              <div class="slot loading-block"></div>
              <div class="slot loading-block"></div>
              <div class="slot loading-block"></div>
              <div class="slot loading-block"></div>
              <div class="slot loading-block"></div>
            </div>
            <button
              v-if="slot"
              @click="modal = true"
              class="appointment-button"
            >
              Выбрать
            </button>
          </div>
          <div v-else class="empty-date">
            Выберите дату приема
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <button @click="toBack(1)" class="appointment-button">Назад</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import FullCalendar from '@fullcalendar/vue';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import ruLocale from '@fullcalendar/core/locales/ru';
import { specialtyApi, doctorApi, timetableApi, chatApi } from '../../../services';
import CustomList from '@app/components/uikit/CustomList.vue';
import { theme } from '@app/theme';
import parse from 'parse-color';

export default {
  components: {
    FullCalendar, CustomList
  },
  data: () => ({
    current_doctor: '',
    modal: false,
    appointmentLoading: false,
    calendarPlugins: [interactionPlugin, dayGridPlugin],
    locale: ruLocale,
    loading: false,
    specialtiesLoading: false,
    timetableLoading: false,
    slotsLoading: false,
    step: 0,
    specialty: null,
    specialties: [],
    doctor: null,
    doctors: [],
    slots: [],
    slot: null,
    selectedDate: null,
    typeAppointment: 0,  //тип зписи, где 0 - запись очно, 1 - запись на видеоконсультацию
    attributes: {
      ref: 'openIndicator',
      role: 'presentation',
      class: 'vs__open-indicator'
    },
    ...theme
  }),
  computed: {
    color() {
      const { rgb } = parse(this.primaryColor);
      return {
        '--primary-color': this.offsetColor(rgb, 50),
        '--secondary-color': this.offsetColor(rgb, 100),
      };
    },
    highlightLinearGradient() {
      const { rgb } = parse(this.primaryColor);
      const lightColor = this.offsetColor(rgb, 80);
      const rightColor = this.offsetColor(rgb, 140);
      return { background: `linear-gradient(90deg, ${lightColor}, ${rightColor})` };
    },
    linearGradient() {
      const { rgb } = parse(this.primaryColor);
      const rightColor = this.offsetColor(rgb, 60);
      return { background: `linear-gradient(90deg, ${this.primaryColor}, ${rightColor})` };
    },
    reverseLinearGradient() {
      const { rgb } = parse(this.primaryColor);
      const rightColor = this.offsetColor(rgb, 60);
      return { background: `linear-gradient(-90deg, ${this.primaryColor}, ${rightColor})` };
    },
    shortDate() {
      return moment(this.selectedDate).format('dddd DD');
    },
    shortTimestamp() {
      return `${moment(this.selectedDate).format('dddd, DD MMM')} ${
        this.slot.time
      }`;
    }
  },
  watch: {
    modal(show) {
      const el = document.body;
      if (show) {
        el.classList.add('modal-open');
      } else {
        el.classList.remove('modal-open');
      }
    },
    step(step) {
      if (step === 0) {
        this.selectedDate = null;
      }
    },
    async selectedDate(date) {
      this.loadSlots(date);
    },
    async specialty(specialty) {
      if (!specialty) {
        this.doctors = [];
        return;
      }
      this.loading = true;
      const { items } = await doctorApi.getBySpecialty(specialty.id);
      this.doctors = items.map(({ id, employee, department, specialty }) => ({
        id,
        name: `${employee.lastName} ${employee.firstName} ${employee.middleName}`,
        department: department.title,
        specialty: specialty.title,
        avatar: employee.avatar
      }));
      // this.current_doctor = this.doctors[0];
      this.clickCurrentDoctor(this.doctors[0]);
      this.loading = false;
    },
    '$route.path': 'getData'
  },
  async created() {
    moment.locale('ru');
    this.specialtiesLoading = true;
    const response = await specialtyApi.getAll();
    this.specialties = response.items.map(obj => { obj.selected = false; return obj;});
    this.specialty = this.specialties[0];
    this.specialtiesLoading = false;
  },
  methods: {
    offsetColor([red, green, blue], offset) {
      return `rgb(${this.clipColor(red, offset)}, ${this.clipColor(green, offset)}, ${this.clipColor(blue, offset)})`;
    },
    clipColor(color, diff) {
      const value = color + diff;
      return value > 0 ? value < 255 ? value : 255 : 0;
    },
    test(evt) {
       if (evt.srcElement.className.includes('fc-today-button')) {
        this.selectedDate = moment(new Date()).format('YYYY-MM-DD');
        document.getElementsByClassName('fc-today-button')[0].disabled = false;
       }
    },
    async clickCurrentDoctor(special) {
      if (special) {
        if (document.getElementById('appointik')) {
          document.getElementById('appointik').scrollIntoView({behavior: 'smooth', block: 'center', inline: 'start'});
      }
        const { items } = await doctorApi.getAvalibleDates(
          special.id
        );
          if(items.length > 0) {
            special.freeDates = true;
          } else {
            special.freeDates = false;
          }
        this.current_doctor = special;
      } else {
        this.current_doctor = null;
      }
    },
    async getData() {
      this.specialtiesLoading = true;
      const response = await specialtyApi.getAll();
      this.specialties = response.items.map(obj => { obj.selected = false; return obj;});
      this.specialty = this.specialties[0];
      this.specialtiesLoading = false;
    },
    async appointmentSlot() {
      this.appointmentLoading = true;
      const { id } = this.slot;
      try {
        console.log(this.slot, this.selectedDate);
        await timetableApi.reserveSlot(id, {type: this.typeAppointment});
        await this.$store.dispatch('permission/loadPermissions');
        this.appointmentLoading = false;
        this.modal = false;
        if (this.typeAppointment === 1) {
          const name = 'Комната приема пациента: ' + this.$store.state.auth.user.last_name + ' ' + this.$store.state.auth.user.first_name + ' ' + this.selectedDate + ' ' + this.slot.time;
          await chatApi.createPrivateChat(id, name);
        }
        this.$router.push({ name: 'appointment.myrecords' });
      } catch (e) {
        this.appointmentLoading = false;
        this.modal = false;
        this.$bvToast.toast(e, {
          title: 'Ошибка',
          autoHideDelay: 10000,
          variant: 'danger'
        });
        await this.reflashSlots(id);
      }
    },
    removeSlot(uuid) {
      const index = this.slots.findIndex(slot => slot.id === uuid);
      this.slots.splice(index, 1);
    },
    selectSlot(slot) {
      this.slot = slot;
    },
    async reflashSlots() {
      await this.loadSlots(this.selectedDate);
    },
    async loadSlots(date) {
      this.slotsLoading = true;
      this.slot = null;
      const { items } = await doctorApi.getAvalibleSlotsByDate(
        this.doctor.id,
        date
      );
      this.slots = items.map(({ id, end_time, start_time, record_mode }) => ({
        id,
        time: `${start_time.slice(-8, -3)}-${end_time.slice(-8, -3)}`,
        record_mode
      }));
      this.slotsLoading = false;
    },
    dateClick({ dateStr, dayEl }) {
      this.selectedDate = dayEl.classList.contains('avalible') ? dateStr : null;
    },
    async handleDatesRender({ view }) {
      this.timetableLoading = true;
      const { activeEnd, activeStart, dayGrid } = view;
      const format = 'YYYY-MM-DD';
      const start = moment(activeStart).format(format);
      const end = moment(activeEnd).format(format);
      dayGrid.cellEls.forEach(el => {
        if (typeof el.dataset.date === 'undefined') {
          return;
        }
        const emptyEl = document.createElement('div');
        emptyEl.className = 'empty-cell';
        emptyEl.innerText = 'ЗАПИСИТЬ НЕ ВЕДЕТСЯ';
        el.append(emptyEl);
      });
      const { items } = await doctorApi.getAvalibleDates(
        this.doctor.id,
        start,
        end
      );
      const avalibleDates = items.map(d => d.date);
      dayGrid.cellEls
        .filter(
          el =>
            typeof el.dataset.date !== 'undefined' &&
            avalibleDates.indexOf(el.dataset.date) > -1
        )
        .forEach(el => {
          el.classList.add('avalible');
          el.innerHTML = '';
        });
      this.timetableLoading = false; 
      document.getElementsByClassName('fc-today-button')[0].disabled = false;
      this.$refs.fullCalendar.$el.addEventListener('click', this.test);
    },
    toBack(step) {
      this.step = step;
    },
    selectTime() {
      this.step = 2;
    },
    selectDoctor(doctor, type) {
      this.step = 1;
      this.doctor = doctor;
      this.typeAppointment = type;
    }
  }
};
</script>

<style lang="scss">
/* fullcalendar styles */
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';

$primary-color: #6cbdee;

.fade-enter-active {
  transition: opacity 100ms;
}
.fade-enter {
  opacity: 0;
}
.bounce-enter {
  transform: scale(0);
}
.bounce-enter-active {
  animation: bounce-in 100ms;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
.form .dialog-overlay {
  z-index: 1002;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.125);
}
.form .dialog-overlay .dialog {
  position: relative;
  overflow: hidden;
  background-color: #fff;
  border-radius: 0.25rem;
  padding: 1rem;
  width: 40vw;
  box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
    0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
}
.form .dialog-overlay .dialog-header {
  border-bottom: 1px solid #f3f3f3;
  padding: 0.5rem 1rem 1rem;
  font-size: 1.2rem;
  text-align: center;
  color: #5a5b60;
}
.form .dialog-overlay .dialog-content {
  padding: 1rem;
}
.form .dialog-overlay .dialog-footer {
  text-align: right;
}
.form .dialog-overlay .dialog-footer button {
  border: 0;
  background-color: #fff;
  font-weight: 600;
  border-radius: 3px;
  padding: 0.5rem 1rem;
  margin: 0;
  color: rgba(0, 0, 0, 0.86);
  outline: none;
}
.form .dialog-overlay .dialog-footer button:hover {
  background-color: rgba(0, 0, 0, 0.064);
}
.dialog-loading-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.mv-list {
  display: flex;
  flex-direction: column;
}
.mv-item {
  display: flex;
  margin-bottom: 0.5rem;
}
.mv-time {
  font-size: 1.1rem;
  margin-bottom: 1rem;
  text-align: center;
  color: #545657;
}
.mv-name {
  width: 40%;
  color: #b6bbc0;
}
.mv-value {
  width: 60%;
  color: #737373;
}
.stepper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.stepper .step {
  display: flex;
  align-items: center;
}
.stepper .step .number {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-weight: 600;
  margin-right: 12px;
}
.stepper .step .title {
  color: rgba(0, 0, 0, 0.5);
}
.stepper .step.complete .number,
.stepper .step.active .number {
  color: #fff;
  background-color: $primary-color;
}
.stepper .step.complete .title,
.stepper .step.active .title {
  color: #212529;
}
.v-select {
  width: 400px;
  margin-bottom: 24px;
}
@media (min-width: 320px) and (max-width: 400px) {
  .v-select {
    width: 300px;
  }
}
.doctor-card {
  display: flex;
  margin-bottom: 12px;
  padding: 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.02);
}
.doctor-card .title {
  font-size: 1.5rem;
  color: #212529;
  margin-bottom: 6px;
}
.doctor-card .subtitle {
  font-size: 13px;
  color: #6c757d;
}
.doctor-card .more {
  display: flex;
  margin-left: auto;
  align-items: flex-end;
}
.loading-block {
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #ececec;
  background: linear-gradient(to right, #f7f7f7 8%, #ececec 38%, #f7f7f7 54%);
  background-size: 1000px 640px;
  position: relative;
}
.doctor-card.loading .title {
  height: 36px;
  width: 320px;
}
.doctor-card.loading .subtitle {
  height: 19px;
  width: 190px;
}
.doctor-card.loading .more {
  height: 42px;
  width: 120px;
}
.empty-date,
.empty-list {
  padding: 0.25rem;
  font-size: 1.2rem;
  font-weight: 300;
  color: #6c757d;
}
.empty-date {
  font-size: 1rem;
}
.appointment-button {
  font-weight: 300;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  color: $primary-color;
  padding: 0.5rem 1rem;
  transition: all 200ms;
  outline: none;
}
.appointment-button:hover {
  border: 1px solid $primary-color;
  background-color: $primary-color;
  color: #fff;
}
.timetable {
  display: flex;
}
.fullcalendar-wrap {
  position: relative;
  width: 70%;
}
.fullcalendar-wrap .overlay {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.7);
  top: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  z-index: 2;
}
.spinner-border {
  color: $primary-color;
}
@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
.fc-toolbar {
  padding: 0;
}
.form .fc-widget-header {
  border: 1px solid #f2f7f8 !important;
}
.form .fc-unthemed .fc-today.fc-day-top {
  background-color: transparent !important;
}
.form .fc-ltr .fc-dayGrid-view .fc-day-top .fc-day-number {
  float: left;
}
.form .fc-unthemed td .empty-cell {
  margin-top: 29px;
  font-size: 10px;
  padding: 2px;
  color: #6c757d;
  font-weight: 300;
}
.form .fc-day.avalible {
  background: linear-gradient(to top, #c8e6c9, #d8fdda);
}
.form .fc-unthemed .fc-today.avalible {
  background: linear-gradient(to top, #c8e6c9, #d8fdda) !important;
}
.form .fc-toolbar h2 {
  font-size: 1rem;
}
.form .fc-button-primary {
  background: linear-gradient(to top, #6cbdee, transparent);
  background-color: unset !important;
}

.form .sidebar {
  width: 30%;
  padding-left: 1rem;
}
.form .sidebar .title {
  margin-bottom: 1rem;
}
.form .slots {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: space-between;
  padding-bottom: 1rem;
}
.form .slot {
  cursor: pointer;
  width: 90px;
  text-align: center;
 // background-color: #a5d6a7;
 background: linear-gradient(to bottom, #c8e6c9, #a5d6a7);
  padding: 0.25rem;
  border-radius: 0.25rem;
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
  min-height: 27px;
  color: #1b5e20;
  font-weight: 600;
}
.form .slot.selected {
 // background-color: #75a478;
  background: linear-gradient(to right, var(--primary-color), var(--secondary-color));
  color: #fff;
  outline: 0;
}
.slot:disabled {
  background: #b6bbc0;
}
.form .fc-button-primary,
.form .fc-button-primary:disabled {
  background-color: $primary-color;
  border-color: $primary-color;
}
.header {
 // margin-bottom: 2rem;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
.header .selected-doctor .title {
  font-size: 1.5rem;
}
.header .selected-doctor .subtitle {
  font-size: 0.9rem;
  color: #6c757d;
}
.form .spetialty-select .vs__search::placeholder {
  color: #6c757d;
}
.form .spetialty-select .vs__open-indicator svg {
  color: #6c757d;
}
.form .spetialty-select .vs__dropdown-option--highlight,
.form .spetialty-select .vs__dropdown-option:hover {
  background-color: $primary-color;
}


.fade-enter,
.fade-leave-active {
    opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s ease;
}
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border: none;
  outline: none;
}
.headtitle {
  font-size: 20px;
  text-align: left;
  background: linear-gradient(90deg,#9b35f5, #9198e5);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  padding: 5px 20px;
  color: white;
}
.arrow-down {
  margin-top: 5px;
  transition: color .3s linear;
}
.arrow-down:hover {
  color: #fc8ecc;
}
.specialities_list{
  background-color: #fff;
  list-style: none;
}
.list-wrap {
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
}
.special {
  padding: 10px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, .125);
  cursor: pointer;
}
.selected {
  background: linear-gradient(to right, #e0b1ff, #d6daf7);
}
button.vm-button.ara {
  padding: 0.5rem 1rem;
}

//.form .fc-day.avalible {
//  background: linear-gradient(to right, rgba(163, 44, 223, 0.5), rgba(92, 72, 212, 0.5));
//}

.fc table {
  border-spacing: 3px 2px;
    border-collapse: separate;
}
.form .fc-day {
  border-radius: 10px;
}
.form .fc-widget-header {
  border: none !important;
}
.fc th, .fc td {
  border-style: none;
}
.fc-highlight {
  background: linear-gradient(to right, var(--primary-color), var(--secondary-color));
  opacity: 1;
  border-radius: 10px;
}

.fc-toolbar.fc-header-toolbar{
  margin-bottom: 0;
}


.item {
  width: 90%;
  display: flex;
  margin-top: 1.5rem;
 /* border: 1px solid #dfdfdf;
  border-radius: 0.25rem; */
  background-color: white;
 /* box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.02); */
  transition: background-color 200ms ease;
  overflow: hidden;
  height:120px; 
  background: linear-gradient(to right, rgb(224, 222, 222), transparent)
}


.item-logo {
  height: 100px;
  overflow: hidden;
  flex: 0 0 100px;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.05);
  transform: translate(0px, -15px);
  position: absolute;
  width: 95px;
}
.item-logo img {
  max-width: 100%;
  max-height: 100%;
}
.item-logo svg {
  width: 50px;
  height: 50px;
}

.vm-item-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 160px;
}
.vm-item-info .title {
  font-size: 1.5rem;
  color: #262626;
  margin-bottom: 6px;
  line-height: 1;
}
.vm-item-info .subtitle {
  color: #606368;
  line-height: 1;
}
.vm-item-action {
  margin-left: auto;
  display: flex;
  align-items: flex-end;
  padding: 1rem;
  flex-direction: column;
  justify-content: space-between;
}
</style>
